import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules } from '@/support/ValidationRules';
import { Size } from '@/models/Size';

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected size!: Size;

  protected newSize: Size = new Size();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.size) {
      this.newSize = this.size.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newSize.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if(!this.newSize) {
      return;
    }

    this.newSize
      .update()
      .then((size: Size) => {
        this.isLoading = false;
        this.$emit('sizeUpdated', size);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveSize) {
      return;
    }

    this.isLoading = true;
    this.newSize
    .create()
    .then((size: Size) => {
      this.isLoading = false;
      this.$emit('sizeCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveSize() {
    if(this.newSize && this.newSize.name && this.newSize.name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    return this.size
      ? 'Edit'
      : 'Add';
  }

  protected clear() {
    this.newSize = new Size();
  }
}
